import { ReactNode, createContext, useContext } from 'react';
import useFetchPartnerInvoices from '../hooks/useApi/useFetchPartnerInvoices';

import type { PartnerInvoicesRequestParams, PartnerInvoicesResponse } from '../hooks/useApi/useFetchPartnerInvoices';

type PartnerInvoicesCtx = {
  response: PartnerInvoicesResponse | undefined;
  refreshPartnerInvoices: (requestParams: PartnerInvoicesRequestParams) => void;
  reset: () => void;
};

const defaultData = { success: false, errorMessage: '', partnerInvoices: [] };

export const PartnerInvoicesContext = createContext<PartnerInvoicesCtx>({
  response: defaultData,
  refreshPartnerInvoices: () => {},
  reset: () => {},
});

export const PartnerInvoicesProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, refreshPartnerInvoices, reset] = useFetchPartnerInvoices({});

  return (
    <PartnerInvoicesContext.Provider
      value={{
        response,
        refreshPartnerInvoices,
        reset,
      }}
    >
      {children}
    </PartnerInvoicesContext.Provider>
  );
};

export const usePartnerInvoices = (): PartnerInvoicesCtx => useContext(PartnerInvoicesContext);
